
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/color-picker",
      function () {
        return require("private-next-pages/color-picker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/color-picker"])
      });
    }
  